export const dataModel = {
  url: "/api/programlisting",
  initialResults: 15, // number of results on first page
  perPage: 15, // number of additional results when load more is clicked
  loadMore: true,
  loadMoreText: "See More Programs",
  includeSearchBar: false, // hide search bar if false
  searchPlaceholder: "Search Programs", // placeholder on search bar
  sortByLabel: "Sort By",
  sorters: [
    {
      id: "{73BB7250-3ED4-439B-94EF-348B976DFD02}",
      label: "Program Name",
      value: "programName",
      direction: "asc",
      isActive: true,
    },
    {
      id: "{E1561986-1ADB-48A3-AF17-B76F3AC74118}",
      label: "Start Date",
      value: "date",
      direction: "asc",
      isActive: false,
    },
    {
      id: "{CF815CF3-0E8C-49AC-9F66-653803FE8619}",
      label: "Topic",
      value: "topic",
      direction: "asc",
      isActive: false,
    },
  ],
  showFacetsLabel: "Filters",
  clearAllLabel: "Reset",
  facetKeys: ["facultyType, departments"],
  ad1: {
    type: "ad",
    url: "/",
    title:
      "One: Tour the Allen Center, Kellogg’s in-person immersive learning environment",
    target: "",
    image: {
      grid1x: "https://via.placeholder.com/342x285",
      grid2x: "https://via.placeholder.com/684x570",
    },
  },
  ad2: {
    type: "ad",
    url: "/",
    title:
      "Two: Tour the Allen Center, Kellogg’s in-person immersive learning environment",
    target: "",
    image: {
      grid1x: "https://via.placeholder.com/342x285",
      grid2x: "https://via.placeholder.com/684x570",
    },
  },
};

export const dataQuery = {
  pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
  listingId: "dfa28f3c-f7b7-45bd-b789-91cd2a2547cd",
};

export const mockApiResponse = {
  request: {
    pageId: "7d7c07a0-4748-4e16-a1f3-28b1af3f2a3a",
    page: 1,
    perPage: 5,
    sortBy: "date",
    sortOrder: "desc",
    queryParameters: {},
  },
  totalResults: 8436,
  results: [
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9500}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description:
        "This highly interactive, live virtual program positions the high-performing, emerging leader to make bold career moves, laying the foundation for general management and leadership of the broader business. Through an exploration of strategic business functions with some of Kellogg’s leading faculty, you will immerse yourself in how to lead in a complex, competitive, global market.",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9501}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9502}",
      eyebrow: "Leadership",
      title:
        "Applied marketing analytics: machine learning and predictive models for improved marketing",
      url: "/programs/full-time-mba.aspx",
      description:
        "This highly interactive, live virtual program positions the high-performing, emerging leader to make bold career moves, laying the foundation for general management and leadership of the broader business. Through an exploration of strategic business functions with some of Kellogg’s leading faculty, you will immerse yourself in how to lead in a complex, competitive, global market.",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9503}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9504}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9505}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9506}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9507}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9508}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9509}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9510}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9511}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9512}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9513}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9514}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9515}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9516}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9517}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9518}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9519}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
    {
      type: "program",
      key: "{FECC0C6F-E172-45B6-82CE-21ABEA8A9520}",
      eyebrow: "Leadership",
      title: "Leading High-Impact Teams",
      url: "/programs/full-time-mba.aspx",
      description: "Lorem ipsum...",
      sessions: [
        {
          dates: "Jan. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
        {
          dates: "Oct. 23-27, 2022",
          type: "Online",
          cost: "$5,000",
        },
      ],
    },
  ],
  facets: [
    {
      id: "topics",
      label: "Topics",
      values: [
        {
          id: "Tenure-line",
          name: "Tenure-line",
          count: 1017,
          selected: false,
          childValues: [],
        },
        {
          id: "Clinical",
          name: "Clinical",
          count: 615,
          selected: false,
          childValues: [],
        },
        {
          id: "Emeritus",
          name: "Emeritus",
          count: 979,
          selected: false,
          childValues: [],
        },
        {
          id: "Other",
          name: "Other",
          count: 979,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
    {
      id: "management",
      label: "Management Level",
      values: [
        {
          id: "Accounting Information & Management",
          name: "Accounting Information & Management",
          count: 690,
          selected: false,
          childValues: [],
        },
        {
          id: "Finance",
          name: "Finance",
          count: 1252,
          selected: false,
          childValues: [],
        },
        {
          id: "Management & Organizations",
          name: "Management & Organizations",
          count: 1204,
          selected: false,
          childValues: [],
        },
        {
          id: "Managerial Economics & Decision Sciences",
          name: "Managerial Economics & Decision Sciences",
          count: 776,
          selected: false,
          childValues: [],
        },
        {
          id: "Marketing",
          name: "Marketing",
          count: 330,
          selected: false,
          childValues: [],
        },
        {
          id: "Operations",
          name: "Operations",
          count: 300,
          selected: false,
          childValues: [],
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 769,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
    {
      id: "format",
      label: "Learning Format",
      values: [
        {
          id: "Accounting Information & Management",
          name: "Accounting Information & Management",
          count: 690,
          selected: false,
          childValues: [],
        },
        {
          id: "Finance",
          name: "Finance",
          count: 1252,
          selected: false,
          childValues: [],
        },
        {
          id: "Management & Organizations",
          name: "Management & Organizations",
          count: 1204,
          selected: false,
          childValues: [],
        },
        {
          id: "Managerial Economics & Decision Sciences",
          name: "Managerial Economics & Decision Sciences",
          count: 776,
          selected: false,
          childValues: [],
        },
        {
          id: "Marketing",
          name: "Marketing",
          count: 330,
          selected: false,
          childValues: [],
        },
        {
          id: "Operations",
          name: "Operations",
          count: 300,
          selected: false,
          childValues: [],
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 769,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
    // {
    //   id: "industry",
    //   label: "Industry",
    //   values: [
    //     {
    //       id: "Accounting Information & Management",
    //       name: "Accounting Information & Management",
    //       count: 690,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Finance",
    //       name: "Finance",
    //       count: 1252,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Management & Organizations",
    //       name: "Management & Organizations",
    //       count: 1204,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Managerial Economics & Decision Sciences",
    //       name: "Managerial Economics & Decision Sciences",
    //       count: 776,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Marketing",
    //       name: "Marketing",
    //       count: 330,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Operations",
    //       name: "Operations",
    //       count: 300,
    //       selected: false,
    //       childValues: [],
    //     },
    //     {
    //       id: "Strategy",
    //       name: "Strategy",
    //       count: 769,
    //       selected: false,
    //       childValues: [],
    //     },
    //   ],
    //   childGroups: [],
    // },
    {
      id: "dateRange",
      label: "Date Range",
      values: [
        {
          id: "Accounting Information & Management",
          name: "Accounting Information & Management",
          count: 690,
          selected: false,
          childValues: [],
        },
        {
          id: "Finance",
          name: "Finance",
          count: 1252,
          selected: false,
          childValues: [],
        },
        {
          id: "Management & Organizations",
          name: "Management & Organizations",
          count: 1204,
          selected: false,
          childValues: [],
        },
        {
          id: "Managerial Economics & Decision Sciences",
          name: "Managerial Economics & Decision Sciences",
          count: 776,
          selected: false,
          childValues: [],
        },
        {
          id: "Marketing",
          name: "Marketing",
          count: 330,
          selected: false,
          childValues: [],
        },
        {
          id: "Operations",
          name: "Operations",
          count: 300,
          selected: false,
          childValues: [],
        },
        {
          id: "Strategy",
          name: "Strategy",
          count: 769,
          selected: false,
          childValues: [],
        },
      ],
      childGroups: [],
    },
  ],
};
